import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock, LogIn } from "lucide-react";
import { toast } from "sonner";
import { login } from "./api";
import { LOGO_URL } from "../data/site";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    try {
      const data = await login(email.trim().toLowerCase(), password);
      localStorage.setItem("udp_admin_token", data.token);
      localStorage.setItem("udp_admin_email", data.email);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Invalid credentials";
      toast.error(typeof msg === "string" ? msg : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen flex items-center justify-center px-6 bg-[#050a18]"
    >
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center mb-8">
          <img src={LOGO_URL} alt="UDP" className="w-16 h-16 rounded-full ring-1 ring-[#c5a059]/40 mb-4" />
          <div className="text-[10px] tracking-[0.4em] text-[#c5a059] uppercase mb-2">Admin Portal</div>
          <h1 className="font-serif-display text-3xl">Universal Dream Properties</h1>
        </div>

        <form onSubmit={submit} className="glass-strong rounded-2xl p-8 space-y-6" data-testid="admin-login-form">
          <div>
            <label className="text-[10px] tracking-[0.3em] uppercase text-white/50">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="udp-input mt-2"
              placeholder="admin@udp.ae"
              data-testid="admin-email-input"
              autoComplete="email"
            />
          </div>
          <div>
            <label className="text-[10px] tracking-[0.3em] uppercase text-white/50">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="udp-input mt-2"
              placeholder="••••••••"
              data-testid="admin-password-input"
              autoComplete="current-password"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="btn-premium w-full py-4 rounded-lg text-sm font-bold tracking-[0.3em] flex items-center justify-center gap-3 disabled:opacity-70"
            data-testid="admin-login-submit"
          >
            {loading ? (
              <>
                <Loader2 className="animate-spin" size={18} /> SIGNING IN…
              </>
            ) : (
              <>
                <LogIn size={16} /> SIGN IN
              </>
            )}
          </button>

          <div className="flex items-center gap-2 justify-center text-white/40 text-[10px] tracking-[0.3em] uppercase">
            <Lock size={11} /> Encrypted admin access
          </div>
        </form>
      </div>
    </div>
  );
}
